<!-- 图表提示弹窗 -->
<template>
  <div v-if="!$isEmpty(content[modalType])" class="legend-modal-box">
    <div class="legend-modal-container">
      <div class="content">
        <div class="title">{{title[modalType]}}</div>
        <div class="content-text">
          <p v-for="item in content[modalType]" :key="item">{{item}}</p>
        </div>
      </div>
      <div class="btn-group">
        <div v-if="!$isEmpty(confirmText[modalType])"
          :style="{ color: confirmColor[modalType] || '#000000'}"
          @click="() => { this.$emit('clickConfirm')}"
          class="btn-item"
          >{{confirmText[modalType]}}</div>
        <div v-if="!$isEmpty(cancelText[modalType])"
          :style="{
            color: cancelColor[modalType] || '#000000',
            borderLeft: $isEmpty(confirmText[modalType]) ? '' : '1px solid #eeeeee'
          }"
          @click="() => { this.$emit('clickCancel')}"
          class="btn-item"
        >{{cancelText[modalType]}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'legend-tip-modal',

  props: {
    modalType: {
      type: String,
      default: '',
    },
    detailInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      title: {
        'type-point': '',
        'type-rank': '',
        'bench-point': '业绩比较基准',
        'day-rise': '日增长率为空的原因',
        'smart-fixed': '',
        annualizationOf7D: '', // 历史7日年化
        zjl: '', // 折价率
      },
      cancelText: {
        'type-point': '知道了',
        'type-rank': '知道了',
        'bench-point': '知道了',
        'day-rise': '知道了',
        'smart-fixed': '我知道了',
        annualizationOf7D: '知道了',
        zjl: '知道了',
      },
      cancelColor: {
        'type-point': '#ff4400',
        'type-rank': '#ff4400',
        'bench-point': '#ff4400',
        'day-rise': '#ff4400',
        'smart-fixed': '#ff4400',
        annualizationOf7D: '#000000',
      },
      confirmText: {
        'type-point': '了解详情',
        'type-rank': '了解详情',
      },
      confirmColor: {
        'type-point': '#000000',
        'type-rank': '#000000',
      },
    };
  },

  computed: {
    content() {
      return {
        'type-point': ['平台采用最新同类分类，在原有一级分类基础上按照资产纬度向下细分，用更科学的方法计算平均值做参考。如：混合型-偏股、混合型-偏债。'],
        'type-rank': ['平台采用最新同类排行，在原有一级分类基础上按照资产维度向下细分，用更加科学的方法在同一维度内进行对比。如：混合型-偏股、混合型-偏债。'],
        'bench-point': [`当前基金的业绩比较基准公式：${this.detailInfo?.benchmark || '--'}`,
          '业绩比较基准是管理人制定的反映基金风险收益特征的重要指标，'
          + '业绩比较基准仅供参考，不构成基金业绩表现的保证。',
          '说明：为确保数据准确性对于成立时长超过5年的基金仅展示近5年业绩基准数据，'
          + '若近5年业绩基准计算方法有变更则为变更前后的累加数据；'
          + '因业绩基准会多次变更仅展示最新业绩基准计算方法；展示“--“为数据更新时间或无数据'],
        'day-rise': ['1、非工作日净值不参与日增长率计算（灰色数据行）。',
          '2、上一交易日净值未披露，日增长率无法计算。'],
        'smart-fixed': [`智能定投为您展示基金长期表现较优的${this.detailInfo?.bestFixedInvestStrategy}策略。`],
        annualizationOf7D: ['*代表多天合并数据'],
        zjl: ['估值折价率 = （实时估值-最新价）/ 实时估值*100%。数据为正，意为折价'],
      };
    },
  },
};
</script>

<style lang="less" scoped>
.legend-modal-box {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}
.legend-modal-container {
  width: 560px;
  background-color: #ffffff;
  border-radius: 24px;
  .content {
    text-align: center;
    .title {
      font-size: 36px;
      color: #000000;
    }
    .content-text {
      font-size: 32px;
      color: #000000;
      margin-top: 24px;
      line-height: 45px;
      p {
        margin: 0;
      }
    }
    padding: 48px 56px;
    border-bottom: 2px solid #eeeeee;
  }
  .btn-group {
    display: flex;
    flex-direction: row;
    .btn-item {
      text-align: center;
      flex:1;
      box-sizing: border-box;
      font-size: 32px;
      line-height: 112px;
    }
  }
}
</style>
